export default __webpack_public_path__ + "static/media/wetu.3acf1ca0.svg";